export default [
    "de",
    "en",
    "es",
    "fr",
    "it",
    "ja",
    "ko",
    "nl",
    "pl",
    "pt",
    "ru",
    "tr",
    "zh",
    "bg",
    "zh-Hant",
    "hr",
    "cs",
    "da",
    "fi",
    "el",
    "hu",
    "no",
    "ro",
    "sv",
    "th",
    "az",
    "br",
];
